import { WisdomMessageItem } from './wisdom-message-item';
import { useWisdomTranscripts } from '../../../hooks/use-wisdom-transcripts';
import { Spinner } from '@@/ui/components';

export const WisdomTranscript = (props: { assistantId: string; sessionId: string }) => {
  const { data, isLoading } = useWisdomTranscripts({
    assistantId: props.assistantId,
    sessionId: props.sessionId
  });

  if (isLoading) {
    return (
      <div className='h-full px-2'>
        <div className='flex items-center justify-center h-32 text-neutral-500'>
          <Spinner size='md' />
        </div>
      </div>
    );
  }

  if (!data || data.transcript.length === 0) {
    return (
      <div className='h-full px-2'>
        <div className='flex items-center justify-center h-32 text-neutral-500'>
          <p className='text-sm'>No wisdom messages available</p>
        </div>
      </div>
    );
  }

  const sortedMessages = [...data.transcript].sort(
    (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
  );
  return (
    <div className='max-h-full overflow-y-auto'>
      <div className='flex flex-col gap-2 relative py-3'>
        {sortedMessages.map((message, index) => (
          <WisdomMessageItem key={message.messageId} message={message} index={index} />
        ))}
      </div>
    </div>
  );
};
